// https://github.com/stripe/stripe-js#importing-loadstripe-without-side-effects
import {loadStripe} from '@stripe/stripe-js/pure';
import {env} from '~/environment';

const {STRIPE_TOKEN} = env;

export const {loadStripeOnce} = new (class StripeService {
    #loadStripeOnce = () => loadStripe(STRIPE_TOKEN, {locale: 'en'});
    loadStripeOnce = async () => {
        const stripe = await this.#loadStripeOnce();
        if (stripe) {
            this.#loadStripeOnce = () => Promise.resolve(stripe);
        }
        return stripe;
    };
})();
